<fuse-main></fuse-main>


<ngx-spinner
  [zIndex]="99999"
  bdColor="rgba(0,0,0,0.5)"
  size="medium"
  color="#fff"
  type="line-spin-clockwise-fade">
  <p style="font-size: 20px; color: #fff">{{'main.loading' | translate }}</p>
</ngx-spinner>

